import { defineMessage } from 'services/localization';

export const messages = {
    payDescription: defineMessage('pay_approved_bills_dire_access_to_bank_accounts'),
    captureDescription: defineMessage('say_goodbye_to_manual_d_ad_single_or_bulk_files'),
    tryNowButtonText: defineMessage('try_now'),
    learnMore: defineMessage('learn_more'),
};
